import {Pipe, PipeTransform} from '@angular/core';
import {Address} from '@spartacus/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({name: 'transformAddresses'})

export class AddressesFormatterPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {
  }

  transform(address: Address): string {
    const companyName = address.companyName;
    const line1 = address.line1;
    const line2 = !!address.line2 ? ', ' + address.line2 : '';
    const town = !!address.town ? ', ' + address.town : '';
    const postalCode = !!address.postalCode ? ', ' + address.postalCode : '';
    const isoCode = address?.country?.isocode || address?.isoCode || '';

    return this.sanitizer.bypassSecurityTrustHtml(`<div><span data-cy="address__companyName">${companyName}</span><br/><span data-cy="address__address">${line1}${line2}${town}${postalCode}</span><br/><span data-cy="address__country">${isoCode}</span></div>`) as string;
  }
}
